import ReactDOM from "react-dom";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "@/theme/muiTheme";
import { LanguageProvider } from "@/langs/LanguageProvider";

export const ReactRender = (component, dom) => {
  return ReactDOM.render(
    <ThemeProvider theme={theme}>
      <LanguageProvider>{component}</LanguageProvider>
    </ThemeProvider>,
    dom
  );
};
